import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';

const LeReconDoc = ({
  formSubmissionPayload,
  entityData,
  baseParagraph,
  baseLayout,
  baseSelect,
  baseMultiSelect,
  props,
  fetchDataFromEntity = false,
  fetchReconDataFrom = [],
  addExtraOptions = false,
  extraOptions = [],
}) => {
  const [renderingLayout, setRenderingLayout] = useState(null);

  useEffect(() => {
    const finalLayout = [];
    let leOptions = [];
    const data = formSubmissionPayload.leReconData;
    if (fetchDataFromEntity) {
      const reconData = fetchReconDataFrom.reduce((acc, el) => {
        if (entityData[el]) {
          acc = [...acc, ...entityData[el]];
        }
        return acc;
      }, []);
      leOptions = reconData.map(({ _Name: name }) => ({
        value: name,
        label: name,
        id: name,
      }));
    } else {
      // dropdown options are same for all the account numbers -->
      leOptions = data.leNames.map((name) => ({
        value: name,
        label: name,
        id: name,
      }));
    }

    if (addExtraOptions) {
      const formattedExtraOptions = extraOptions.map((name) => ({
        value: name,
        label: name,
        id: name,
      }));
      leOptions = [...leOptions, ...formattedExtraOptions];
    }

    if (data) {
      data.accountNumbers.forEach((accountNumber, index) => {
        const labelRow = structuredClone(baseParagraph);
        let selectDropdownRow;
        const baseLayoutClone = structuredClone(baseLayout);
        // create paragraph row with account number
        labelRow.childElements[0].fieldValue = accountNumber;

        // create select/multiselect dropdown row with options
        // create dropdown options
        const options = [...leOptions];
        if (accountNumber.includes('BCA')) {
          selectDropdownRow = structuredClone(baseMultiSelect);
        } else {
          selectDropdownRow = structuredClone(baseSelect);
          // append one more empty option to the options at the start
          options.unshift({ value: '', label: '' });
        }
        selectDropdownRow.childElements[0].fieldOptions = options;
        selectDropdownRow.childElements[0].fieldId = accountNumber;
        selectDropdownRow.childElements[0].fieldRank = index + 1;

        // add these rows to base column layout
        baseLayoutClone.childElements[0].childElements.push(labelRow);
        baseLayoutClone.childElements[1].childElements.push(selectDropdownRow);
        finalLayout.push(baseLayoutClone);
      });
      setRenderingLayout(finalLayout);
    }
  }, []);

  return (
    renderingLayout
    && constructChildStructure(renderingLayout, props, 'leReconLayout')
  );
};
/* eslint-enable import/no-cycle -- need */

LeReconDoc.propTypes = {
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  entityData: PropTypes.objectOf(PropTypes.shape),
  baseParagraph: PropTypes.objectOf(PropTypes.shape),
  baseLayout: PropTypes.objectOf(PropTypes.shape),
  baseSelect: PropTypes.objectOf(PropTypes.shape),
  baseMultiSelect: PropTypes.objectOf(PropTypes.shape),
  props: PropTypes.objectOf(PropTypes.shape),
  fetchDataFromEntity: PropTypes.bool,
  fetchReconDataFrom: PropTypes.arrayOf(PropTypes.shape),
  addExtraOptions: false,
  extraOptions: PropTypes.arrayOf(PropTypes.shape),
};

export default LeReconDoc;
